import React from 'react';
import { BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import { Button } from '@chakra-ui/react';
import Header from './Components/Header'
import Footer from './Components/Footer';
import Hii from './Components/Hii';
import Home from "./Components/Home"
import VideosCompo from './Components/VideosCompo';
import Upload from './Components/Upload';
import Login from './Components/Login';
import Signup from './Components/Signup';
const App = () => {
  return (
    <Router>
      <Header/>
      <Routes>
        <Route path='/'element={<Home/>}/>
        <Route path='/videos'element={<VideosCompo/>}/>
        <Route path='/videos?category=free'element={<VideosCompo/>}/>
        <Route path='/upload'element={<Upload/>}/>
        <Route path='/login'element={<Login/>}/>
        <Route path='/signup'element={<Signup/>}/>

      </Routes>
      
   <Footer/>
      </Router>
  )
}

export default App